import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import { FormData, FormRefs, RequiredField, SelectOption } from "../index";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { submitOneTimeAPMCForm } from "../../../auth/services/privateapicalling";
import { fruitOptions,vegetableOptions } from '../../../../core/data/json/role';
import { useNavigate } from 'react-router-dom';

interface Props {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
applicationId:string ;
  handleFileChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    documentName: string,
    subYardIndex?: number // Add this
  ) => void;

  refs: FormRefs;
  requiredFields: RequiredField[];
  errors: { [key: string]: string };
  setErrors: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
  touched: { [key: string]: boolean };
  setTouched: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
  talukaOptions: any[];
  spicesOptions: any[];
  rawPurposes: any[];
}

 

const ApmcDetailApplicationForm: React.FC<Props> = ({
  formData,
  setFormData,
  refs,
  requiredFields,
  errors,
  setErrors,
  applicationId,
  handleFileChange,
  touched,
  setTouched,
  talukaOptions,
  spicesOptions,
  rawPurposes,
}) => {
const [submitLoading,setSubmitLoading] = useState(false);
const formatDate = (dateString: string): string => {
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};
const navigate = useNavigate();

const transformFormDataToPayload = (formData: FormData, userDetail) => {
  const payload: any = {
    departmentId: userDetail.Department_ID,
    districtId: userDetail.Department.district_id,
    registrationDoc: formData.registrationDoc || "",
    registrationDate: formatDate(formData.registrationDate) || "",
    districtName: formData.district || "",
    talukasName: formData.taluka?.map((t) => t.label) || [],
    noOfVillagesmarket: formData.numberOfVillages || "",
    emailID: formData.emailId || "",
    chairmanName: formData.chairmanName || "",
    chairmanMobileNo: formData.chairmanMobile || "",
    secreataryName: formData.secretaryName || "",
    secreataryMobileNo: formData.secretaryMobile || "",
    noOfFarmerApmc: formData.numberOfFarmers || "",
    noOfTraderApmc: formData.numberOfTraders || "",
    noOfAgentsApmc: formData.numberOfCommissionAgents || "",
    noOfSocietesApmc: formData.numberOfCooperatives || "",
    lastElectionDate: formatDate(formData.firstMeetingDate) || "",
    electionResultDoc: formData.firstMeetingDoc || "",
    noOfunifiedLicense: formData.unifiedLicense || "",
    noOfgca: formData.generalCommissionAgents || "",
    approvedStaffDoc: formData.approvedStaffScheduleDoc || "",
    totalApprovlStaff: formData.totalStaffApproved || "",
        totalRecruitStaff: formData.totalStaffRecruited || "",
    noOfotherLicense: formData.otherLicense || "",
    lastAuditDate: formatDate(formData.lastAuditDate) || "",
    lastAuditDoc: formData.auditReport || "",
    byeLawsDoc: formData.byeLawsDoc || "",
    detailsInfrastructureFacilities:
      formData.infrastructureDetails?.map((t) => ({
        id: t.value,
        value: t.label,
      })) || [],
    otherCommoditiesInApmc:
      formData.otherCommodities?.map((t) => t.label) || [],
      mainYardDetails:[{
    name: formData.mainYardName || '',
    date: formatDate(formData.mainYardDate) || '',
    address: formData.mainYardAddress || '',
    doc: formData.mainYardDoc || '',
      }],
    subYardDetails: formData.subYards?.map((yard) => ({
      name: yard.name,
      date: formatDate(yard.date),
      address: yard.address,
      doc: yard.doc || '',
    })) || [],
   
  };
  

  /* ================= Trading Fruits / Vegetables ================= */
  payload.isTradingFruitVeg = [
    {
      fieldName: "isfruitvegetable",
      value: formData.tradingVegetablesFruits || "",
    },
  ];

  if (formData.tradingVegetablesFruits === "yes") {
    payload.isTradingFruitVeg.push(
      {
        fieldName: "fruits",
        value: formData.fruits?.map((f) => f.value) || [],
      },
      {
        fieldName: "vegetables",
        value: formData.vegetables?.map((v) => v.value) || [],
      }
    );
  }

  /* ================= Canteen ================= */
  payload.apmcCanteenFacility = [
    {
      fieldName: "hasCanteen",
      value: formData.hasCanteen || "",
    },
  ];

  if (formData.hasCanteen === "yes") {
    payload.apmcCanteenFacility.push({
      fieldName: "seatingCapacity",
      value: formData.canteenSeatingCapacity || "",
    });
  }

  /* ================= Guest House ================= */
  payload.apmcGuestHouse = [
    {
      fieldName: "hasGuestRoom",
      value: formData.hasGuestHouse || "",
    },
  ];

  if (formData.hasGuestHouse === "yes") {
    payload.apmcGuestHouse.push({
      fieldName: "bedCapacity",
      value: formData.noOfBeds || "",
    });
  }

  /* ================= Private Land ================= */
  payload.apmcPrivateLand = [
    {
      fieldName: "hasPrivateLand",
      value: formData.hasPrivateLand || "",
    },
  ];

  if (formData.hasPrivateLand === "yes") {
    payload.apmcPrivateLand.push(
      {
        fieldName: "hectare",
        value: formData.landHectare || "",
      },
      {
        fieldName: "area",
        value: formData.landAre || "",
      },
      {
        fieldName: "sqmeter",
        value: formData.landSqMeter || "",
      }
    );
  }

  /* ================= Lease Land ================= */
  payload.apmcLeaseLand = [
    {
      fieldName: "hasPrivateLand",
      value: formData.hasLeasedLand || "",
    },
  ];

  if (formData.hasLeasedLand === "yes") {
    payload.apmcLeaseLand.push(
      {
        fieldName: "hectare",
        value: formData.leaseLandHectare || "",
      },
      {
        fieldName: "area",
        value: formData.leaseLandAre || "",
      },
      {
        fieldName: "sqmeter",
        value: formData.leaseLandSqMeter || "",
      },
      {
        fieldName: "leasePeriod",
        value: formData.leasePeriodYears || "",
      }
    );
  }

  return payload;
};

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
    // Add a new sub-yard entry
  const handleAddSubYard = () => {
    setFormData((prev) => ({
      ...prev,
      subYards: [
        ...(prev.subYards || []),
        { name: '', date: '', address: '', doc: null }
      ],
    }));
  };

  // Remove a sub-yard entry
  const handleRemoveSubYard = (index: number) => {
    if (formData.subYards && formData.subYards.length > 1) {
      setFormData((prev) => ({
        ...prev,
        subYards: prev.subYards?.filter((_, i) => i !== index),
      }));
    }
  };

  // Update a specific sub-yard field
  const handleSubYardChange = (
    index: number,
    field: 'name' | 'date' | 'address',
    value: string
  ) => {
    setFormData((prev) => ({
      ...prev,
      subYards: prev.subYards?.map((yard, i) =>
        i === index ? { ...yard, [field]: value } : yard
      ),
    }));
    
    // Clear errors for this field
    setErrors((prev) => ({
      ...prev,
      [`subYards[${index}].${field}`]: "",
    }));
  };

  const userDetail = useSelector((state: any) => state.auth.userDetails);
 
  const token = useSelector((state: any) => state.auth.token);

 

  const handleBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setTouched((prev) => ({ ...prev, [e.target.name]: true }));
  };

 

  const requireIfYes = (
    condition: boolean,
    fields: { key: string; message: string }[],
    errors: { [key: string]: string }
  ) => {
    if (!condition) return;

    fields.forEach(({ key, message }) => {
      if (!formData[key]) {
        errors[key] = message;
      }
    });
  };

  const validate = () => {
    const newErrors: { [key: string]: string } = {};

    // common required fields
    requiredFields.forEach(({ key, message }) => {
      const value = formData[key];

      if (
        value === undefined ||
        value === null ||
        value === "" ||
        (typeof value === "object" && Object.keys(value).length === 0)
      ) {
        newErrors[key] = message;
      }
    });

    // conditional validations
    requireIfYes(
      formData.hasCanteen === "yes",
      [
        {
          key: "canteenSeatingCapacity",
          message: "Canteen seating capacity is required",
        },
      ],
      newErrors
    );

    requireIfYes(
      formData.hasGuestHouse === "yes",
      [{ key: "noOfBeds", message: "Number of beds is required" }],
      newErrors
    );

    requireIfYes(
      formData.hasPrivateLand === "yes",
      [
        { key: "landHectare", message: "Land hectare is required" },
        { key: "landAre", message: "Land are is required" },
        { key: "landSqMeter", message: "Land square meter is required" },
      ],
      newErrors
    );

    requireIfYes(
      formData.hasLeasedLand === "yes",
      [
        { key: "leaseLandHectare", message: "Lease land hectare is required" },
        { key: "leaseLandAre", message: "Lease land are is required" },
        {
          key: "leaseLandSqMeter",
          message: "Lease land square meter is required",
        },
        {
          key: "leasePeriodYears",
          message: "Lease period in years is required",
        },
      ],
      newErrors
    );
    requireIfYes(
      formData.tradingVegetablesFruits === "yes",
      [
        {
          key: "vegetables",
          message: "At least one vegetable is required",
        },
        {
          key: "fruits",
          message: "At least one fruit is required",
        },
      ],
      newErrors
    );
    if (formData.subYards && formData.subYards.length > 0) {
    formData.subYards.forEach((subYard, index) => {
      if (!subYard.name) {
        newErrors[`subYards[${index}].name`] = 'Sub yard name is required';
      }
      if (!subYard.date) {
        newErrors[`subYards[${index}].date`] = 'Sub yard date is required';
      }
      if (!subYard.address) {
        newErrors[`subYards[${index}].address`] = 'Sub yard address is required';
      }
      if (!subYard.doc) {
        newErrors[`subYards[${index}].doc`] = 'Sub yard document is required';
      }
    });
  }

    return newErrors;
  };

  const handleSubmit = async() => {
    setSubmitLoading(true);
    try
{    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const payload = transformFormDataToPayload(formData, userDetail);
     
      const response=await submitOneTimeAPMCForm(token,payload,applicationId);
      if(response?.success){
        toast.success("Form submitted successfully");
        
          setTimeout(() => {
         navigate("/my-apmc-one-time-application");
        }, 1000);
      }else{
        toast.error("Submission failed. Please try again.");
      }
   
    } else {
      const firstErrorKey = Object.keys(validationErrors)[0];
      if (firstErrorKey && refs[firstErrorKey] && refs[firstErrorKey].current) {
        refs[firstErrorKey].current.focus();
      }
      toast.error("Please fill all required fields");
    }}catch (error) {
     
      toast.error("An unexpected error occurred. Please try again later.");
    }finally{
      setSubmitLoading(false);
    }
  };

  





  return (
    <>{submitLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
            <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Submitting...</span>
              </div>
              <div className="fw-bold">Submitting, please wait...</div>
            </div>
          </div>
        )}
    <div className="page-wrapper p-3 mt-5">
      <div className="d-flex flex-column text-nightblue align-items-center justify-content-center">
        <div
          id="table"
          className="w-100 overflow-hidden border bg-white border-secondary rounded mb-5"
        >
          <div
            id="head"
            className="d-flex w-100 rounded-top border-bottom border-secondary"
            style={{ backgroundColor: "#CCE3FF" }}
          >
            <h4 className="col-1 d-flex justify-content-center align-items-center">
              S.No.
            </h4>
            <h4 className="col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary">
              પ્રશ્ન(Field)
            </h4>
            <h4 className="col-5 p-2 justify-content-center d-flex align-items-center">
              જવાબ(Response)
            </h4>
          </div>

          {/* Field 01 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              01.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિની નોંધણી(Registration of the Market Committee)
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="d-flex gap-2 w-75">
                {/* Registration Doc */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="file"
                    name="registrationDoc"
                    onChange={(e) => handleFileChange(e, "registrationDoc")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                    onBlur={handleBlur}
                    ref={refs.registrationDoc}
                  />

                  {formData?.registrationDoc && (
                    <small className="text-success">
                      Uploaded
                    </small>
                  )}

                  {errors?.registrationDoc && (
                    <small className="text-danger">
                      {errors.registrationDoc}
                    </small>
                  )}
                </div>

                {/* Registration Date */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="date"
                    name="registrationDate"
                    value={formData.registrationDate || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.registrationDate}
                  />

                  {errors?.registrationDate && (
                    <small className="text-danger">
                      {errors.registrationDate}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Field 02 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              02.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                તમારા જિલ્લો અને તાલુકા પસંદ કરો(Select your District and
                talukas)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                type="text"
                className="form-control w-75 bg-light"
                value={userDetail?.Department?.District || ""}
                readOnly
              />

              {errors && errors.district && (
                <span className="text-danger small">{errors.district}</span>
              )}

              <Select
                className="w-75"
                isMulti
                options={talukaOptions}
                placeholder="Select Taluka"
                value={formData.taluka}
                onChange={(selected) => {
                  setFormData((prev) => ({
                    ...prev,
                    taluka: selected as SelectOption[],
                  }));

                  setErrors((prev) => ({
                    ...prev,
                    taluka: "",
                  }));
                }}
              />

              {errors && errors.taluka && (
                <span className="text-danger small">{errors.taluka}</span>
              )}
            </div>
          </div>

          {/* Field 03 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              03.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર વિસ્તારમાં આવતા ગામોની સંખ્યા.(Number of villages falling
                within market area)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="numberOfVillages"
                value={formData.numberOfVillages || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.numberOfVillages}
                placeholder="Enter number of villages"
              />
              {errors && errors.numberOfVillages && (
                <span className="text-danger small">
                  {errors.numberOfVillages}
                </span>
              )}
            </div>
          </div>

          {/* Field 04 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              04.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">ઇ-મેલ આઇડી(Email ID)*</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="email"
                name="emailId"
                value={formData.emailId || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.emailId}
                placeholder="Enter Email ID"
              />
              {errors && errors.emailId && (
                <span className="text-danger small">{errors.emailId}</span>
              )}
            </div>
          </div>

          {/* Field 05 */}

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              05.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                ચેરમેન/સેક્રેટરીનું નામ અને મોબાઇલ નંબર (Name & Mobile Number of
                Chairman/Secretary)
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              {/* Chairman row */}
              <div className="d-flex gap-2 w-75">
                {/* Chairman Name */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="text"
                    name="chairmanName"
                    value={formData.chairmanName || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.chairmanName}
                    placeholder="Chairman Name"
                  />
                  {errors?.chairmanName && (
                    <small className="text-danger">{errors.chairmanName}</small>
                  )}
                </div>

                {/* Chairman Mobile */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="tel"
                    name="chairmanMobile"
                    value={formData.chairmanMobile || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.chairmanMobile}
                    placeholder="Mobile Number"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={10}
                  />
                  {errors?.chairmanMobile && (
                    <small className="text-danger">
                      {errors.chairmanMobile}
                    </small>
                  )}
                </div>
              </div>

              {/* Secretary row */}
              <div className="d-flex gap-2 w-75">
                {/* Secretary Name */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="text"
                    name="secretaryName"
                    value={formData.secretaryName || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.secretaryName}
                    placeholder="Secretary Name"
                  />
                  {errors?.secretaryName && (
                    <small className="text-danger">
                      {errors.secretaryName}
                    </small>
                  )}
                </div>

                {/* Secretary Mobile */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="tel"
                    name="secretaryMobile"
                    value={formData.secretaryMobile || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.secretaryMobile}
                    placeholder="Mobile Number"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={10}
                  />
                  {errors?.secretaryMobile && (
                    <small className="text-danger">
                      {errors.secretaryMobile}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Field 06 - Multiple sub-fields */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              06.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં ખેડૂતોની સંખ્યા(Number of
                farmers covered under the jurisdiction of the Market Committee)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="numberOfFarmers"
                value={formData.numberOfFarmers || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.numberOfFarmers}
                placeholder="Enter Number"
              />
              {errors && errors.numberOfFarmers && (
                <span className="text-danger small">
                  {errors.numberOfFarmers}
                </span>
              )}
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં વેપારીઓની સંખ્યા(Number of
                traders coming under the purview of the market committee)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="numberOfTraders"
                value={formData.numberOfTraders || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.numberOfTraders}
                placeholder="Enter Number"
              />
              {errors && errors.numberOfTraders && (
                <span className="text-danger small">
                  {errors.numberOfTraders}
                </span>
              )}
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં કમિશન એજન્ટોની સંખ્યા(Number
                of commission agents coming under the purview of the Market
                Committee)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="numberOfCommissionAgents"
                value={formData.numberOfCommissionAgents || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.numberOfCommissionAgents}
                placeholder="Enter Number"
              />
              {errors && errors.numberOfCommissionAgents && (
                <span className="text-danger small">
                  {errors.numberOfCommissionAgents}
                </span>
              )}
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં સહકારી ખરીદ વેચાણ મંડળીઓની
                સંખ્યા.(Number of cooperative purchase and sale societies
                falling under the purview of the market committee.)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="numberOfCooperatives"
                value={formData.numberOfCooperatives || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.numberOfCooperatives}
                placeholder="Enter Number"
              />
              {errors && errors.numberOfCooperatives && (
                <span className="text-danger small">
                  {errors.numberOfCooperatives}
                </span>
              )}
            </div>
          </div>

          {/* Field 07 */}

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              07.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                નવા ચૂંટણી બાદ APMCની પ્રથમ સામાન્ય બેઠકની તારીખ (Date of the
                First General meeting of APMC after fresh election)*
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              <div className="d-flex gap-2 w-75">
                {/* First Meeting Date */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="date"
                    name="firstMeetingDate"
                    value={formData.firstMeetingDate || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.firstMeetingDate}
                  />
                  {errors?.firstMeetingDate && (
                    <small className="text-danger">
                      {errors.firstMeetingDate}
                    </small>
                  )}
                </div>

                {/* First Meeting Document */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="file"
                    name="firstMeetingDoc"
                    onChange={(e) => handleFileChange(e, "firstMeetingDoc")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                    onBlur={handleBlur}
                    ref={refs.firstMeetingDoc}
                  />

                  {formData?.firstMeetingDoc && (
                    <small className="text-success">
                      Uploaded
                    </small>
                  )}

                  {errors?.firstMeetingDoc && (
                    <small className="text-danger">
                      {errors.firstMeetingDoc}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Field 08 - License Details */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              08.
            </h4>
            <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                લાઇસન્સ ધારક વેપારીઓની વિગતો (કુલ)(Details of license-holding
                traders (Total)):
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">યુનિફાઇડ લાયસન્સ(Unified License)</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="unifiedLicense"
                value={formData.unifiedLicense || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.unifiedLicense}
                placeholder="Enter Number"
              />
              {errors && errors.unifiedLicense && (
                <span className="text-danger small">
                  {errors.unifiedLicense}
                </span>
              )}
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                જનરલ કમિશન એજન્ટ્સ(General commission agents)*
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="generalCommissionAgents"
                value={formData.generalCommissionAgents || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.generalCommissionAgents}
                placeholder="Enter Number"
              />
              {errors && errors.generalCommissionAgents && (
                <span className="text-danger small">
                  {errors.generalCommissionAgents}
                </span>
              )}
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">અન્ય લાયસન્સ(Other License)</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="otherLicense"
                value={formData.otherLicense || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.otherLicense}
                placeholder="Enter Number"
              />
              {errors && errors.otherLicense && (
                <span className="text-danger small">{errors.otherLicense}</span>
              )}
            </div>
          </div>

          {/* Field 09 */}

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              09.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                છેલ્લી ઓડિટની તારીખ દાખલ કરો અને ઓડિટ રિપોર્ટ અપલોડ કરો. (Enter
                the last audit date and upload the audit report)*
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              <div className="d-flex gap-2 w-75">
                {/* Last Audit Date */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="date"
                    name="lastAuditDate"
                    value={formData.lastAuditDate || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.lastAuditDate}
                  />
                  {errors?.lastAuditDate && (
                    <small className="text-danger">
                      {errors.lastAuditDate}
                    </small>
                  )}
                </div>

                {/* Audit Report */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="file"
                    name="auditReport"
                    onChange={(e) => handleFileChange(e, "auditReport")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                    onBlur={handleBlur}
                    ref={refs.auditReport}
                  />

                  {formData?.auditReport && (
                    <small className="text-success">
                      Uploaded
                    </small>
                  )}

                  {errors?.auditReport && (
                    <small className="text-danger">{errors.auditReport}</small>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Field 10 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              10.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">APMC ના પેટા કાયદા(bye laws of APMC)*</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="file"
                onChange={(e) => handleFileChange(e, "byeLawsDoc")}
                name="byeLawsDoc"
                accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                onBlur={handleBlur}
                ref={refs.byeLawsDoc}
              />
              {errors && errors.byeLawsDoc && (
                <span className="text-danger small">{errors.byeLawsDoc}</span>
              )}
              {formData?.byeLawsDoc && (
                <p className="small text-success">
                  Uploaded
                </p>
              )}
            </div>
          </div>

          {/* Field 11 */}

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              11.
            </h4>

            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                મુખ્યયાર્ડ-સરનામા સાથે (Main yard with address)*
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
              {/* Main Yard Name */}
              <div className="d-flex flex-column w-75">
                <input
                  className="form-control"
                  type="text"
                  name="mainYardName"
                  value={formData.mainYardName || ""}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  ref={refs.mainYardName}
                  placeholder="Name of main yard"
                />
                {errors?.mainYardName && (
                  <small className="text-danger">{errors.mainYardName}</small>
                )}
              </div>

              {/* Date + Address */}
              <div className="d-flex gap-2 w-75">
                {/* Date */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="date"
                    name="mainYardDate"
                    value={formData.mainYardDate || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.mainYardDate}
                  />
                  {errors?.mainYardDate && (
                    <small className="text-danger">{errors.mainYardDate}</small>
                  )}
                </div>

                {/* Address */}
                <div className="d-flex flex-column w-50">
                  <input
                    className="form-control"
                    type="text"
                    name="mainYardAddress"
                    value={formData.mainYardAddress || ""}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={refs.mainYardAddress}
                    placeholder="Address"
                  />
                  {errors?.mainYardAddress && (
                    <small className="text-danger">
                      {errors.mainYardAddress}
                    </small>
                  )}
                </div>
              </div>

              {/* Main Yard Document */}
              <div className="d-flex flex-column w-75">
                <input
                  className="form-control"
                  type="file"
                  name="mainYardDoc"
                  onChange={(e) => handleFileChange(e, "mainYardDoc")}
                  accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                  onBlur={handleBlur}
                  ref={refs.mainYardDoc}
                />

                {formData?.mainYardDoc && (
                  <small className="text-success">
                    Uploaded
                  </small>
                )}

                {errors?.mainYardDoc && (
                  <small className="text-danger">{errors.mainYardDoc}</small>
                )}
              </div>
            </div>
          </div>

          {/* Field 12 */}
          {/* Field 12 - Multiple Sub Yards */}
<div className="d-flex border-bottom border-secondary">
  <h4 className="col-1 d-flex align-items-center justify-content-center">
    12.
  </h4>

  <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
    <p className="p-2">
      સબયાર્ડ-સરનામા સાથે (Sub yards with address)*
    </p>
  </div>

  <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
    {(formData.subYards || []).map((subYard, index) => (
      <div key={index} className="w-100 border rounded p-3 position-relative bg-light">
        {/* Remove button */}
        {formData.subYards && formData.subYards.length > 1 && (
          <button
            type="button"
            className="btn text-danger position-absolute"
            style={{ top: '8px', right: '8px', fontSize:"20px" }}
            onClick={() => handleRemoveSubYard(index)}
          >
            ×
          </button>
        )}

        <div className="mb-2">
          <strong>Sub Yard {index + 1}</strong>
        </div>

        {/* Sub Yard Name */}
        <div className="d-flex flex-column w-100 mb-2">
          <input
            className="form-control"
            type="text"
            value={subYard.name || ''}
            onChange={(e) =>
              handleSubYardChange(index, 'name', e.target.value)
            }
            placeholder="Name of Sub yard"
          />
          {errors?.[`subYards[${index}].name`] && (
            <small className="text-danger">
              {errors[`subYards[${index}].name`]}
            </small>
          )}
        </div>

        {/* Date + Address Row */}
        <div className="d-flex gap-2 w-100 mb-2">
          {/* Sub Yard Date */}
          <div className="d-flex flex-column w-50">
            <input
              className="form-control"
              type="date"
              value={subYard.date || ''}
              onChange={(e) =>
                handleSubYardChange(index, 'date', e.target.value)
              }
            />
            {errors?.[`subYards[${index}].date`] && (
              <small className="text-danger">
                {errors[`subYards[${index}].date`]}
              </small>
            )}
          </div>

          {/* Sub Yard Address */}
          <div className="d-flex flex-column w-50">
            <input
              className="form-control"
              type="text"
              value={subYard.address || ''}
              onChange={(e) =>
                handleSubYardChange(index, 'address', e.target.value)
              }
              placeholder="Address"
            />
            {errors?.[`subYards[${index}].address`] && (
              <small className="text-danger">
                {errors[`subYards[${index}].address`]}
              </small>
            )}
          </div>
        </div>

        {/* Sub Yard Document */}
        <div className="d-flex flex-column w-100">
          <input
          name={`subYardDoc${1}`}
            className="form-control"
            type="file"
            onChange={(e) => handleFileChange(e, 'subYardDoc', index)}
            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
          />

          {subYard.doc && (
            <small className="text-success mt-1">
              ✓ Uploaded: {subYard.doc.fileName}
            </small>
          )}

          {errors?.[`subYards[${index}].doc`] && (
            <small className="text-danger">
              {errors[`subYards[${index}].doc`]}
            </small>
          )}
        </div>
      </div>
    ))}

    {/* Add More Button */}
    <button
      type="button"
      className="btn btn-outline-info w-75"
      onClick={handleAddSubYard}
    >
      + Add Another Sub Yard
    </button>
  </div>
</div>

          {/* Field 13 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              13.
            </h4>
            <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">વિવિધ વિગતો (Miscellaneous details)</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                શાકભાજી અને ફળોની વેપાર પ્રવૃત્તિ થાય છે કે નહીં?(Trading in
                Vegetables & Fruits)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="d-flex gap-3 w-75">
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="tradingVegetablesFruits"
                    value="yes"
                    checked={formData.tradingVegetablesFruits === "yes"}
                    onChange={handleInputChange}
                    ref={refs.tradingVegetablesFruits}
                  />
                  Yes
                </label>
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="tradingVegetablesFruits"
                    value="no"
                    checked={formData.tradingVegetablesFruits === "no"}
                    onChange={handleInputChange}
                  />
                  No
                </label>
              </div>
            </div>
          </div>

          {formData.tradingVegetablesFruits === "yes" && (
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center p-2"></div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                {/* Vegetables */}
                <div className="w-100 d-flex flex-column align-items-center gap-2">
                  <p className="m-0">શાકભાજી (Vegetables)</p>
                  <Select
                    className="w-75"
                    isMulti
                    options={vegetableOptions}
                    value={formData.vegetables}
                    onChange={(selected) => {
                      setFormData((prev) => ({
                        ...prev,
                        vegetables: selected,
                      }));

                      setErrors((prev) => ({
                        ...prev,
                        vegetables: "",
                      }));
                    }}
                  />
                  {errors?.vegetables && (
                    <small className="text-danger">{errors.vegetables}</small>
                  )}
                </div>

                {/* Fruits */}
                <div className="w-100 d-flex flex-column align-items-center gap-2">
                  <p className="m-0">ફળો (Fruits)</p>
                  <Select
                    className="w-75"
                    isMulti
                    options={fruitOptions}
                    value={formData.fruits}
                    onChange={(selected) => {
                      setFormData((prev) => ({
                        ...prev,
                        fruits: selected,
                      }));

                      setErrors((prev) => ({
                        ...prev,
                        fruits: "",
                      }));
                    }}
                  />
                  {errors?.fruits && (
                    <small className="text-danger">{errors.fruits}</small>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                એપીએમસીમાં અન્ય કયા માલસામાનનો વેપાર થાય છે(Other Commodities
                Traded in APMC)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <Select
                className="w-75"
                isMulti
                options={spicesOptions}
                value={formData.otherCommodities}
                placeholder="Select Commodities"
                onChange={(selected) => {
                  setFormData((prev) => ({
                    ...prev,
                    otherCommodities: selected as SelectOption[],
                  }));

                  setErrors((prev) => ({
                    ...prev,
                    otherCommodities: "",
                  }));
                }}
              />

              {errors && errors.otherCommodities && (
                <span className="text-danger small w-75">
                  {errors.otherCommodities}
                </span>
              )}
            </div>
          </div>

          {/* Field 14 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              14.
            </h4>
            <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                એપીએમસી સ્ટાફનો સમયપત્રક(APMC Staff Schedule):
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                મંજૂર સ્ટાફ શેડ્યૂલ (Approved staff schedule)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="file"
                onChange={(e) =>
                  handleFileChange(e, "approvedStaffScheduleDoc")
                }
                name="approvedStaffScheduleDoc"
                accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                onBlur={handleBlur}
                ref={refs.approvedStaffScheduleDoc}
              />
              {errors && errors.approvedStaffScheduleDoc && (
                <span className="text-danger small">
                  {errors.approvedStaffScheduleDoc}
                </span>
              )}
              {formData?.approvedStaffScheduleDoc && (
                <p className="small text-success">
                  Uploaded
                </p>
              )}
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                મંજૂરી મુજબ કુલ સ્ટાફ(Total staff as per approval)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="totalStaffApproved"
                value={formData.totalStaffApproved || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.totalStaffApproved}
                placeholder="Enter Number"
              />
              {errors && errors.totalStaffApproved && (
                <span className="text-danger small">
                  {errors.totalStaffApproved}
                </span>
              )}
            </div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                કુલ ભરતી કરાયેલ સ્ટાફ(Total recruited staff)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <input
                className="form-control w-75"
                type="number"
                name="totalStaffRecruited"
                value={formData.totalStaffRecruited || ""}
                onChange={handleInputChange}
                onBlur={handleBlur}
                ref={refs.totalStaffRecruited}
                placeholder="Enter Number"
              />
              {errors && errors.totalStaffRecruited && (
                <span className="text-danger small">
                  {errors.totalStaffRecruited}
                </span>
              )}
            </div>
          </div>

          {/* Field 15 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              15.
            </h4>
            <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">સુવિધાઓની માહિતી(Facility Details)</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                શું એપીએમસીમાં કેન્ટીનની સુવિધા છે?(Whether APMC has Canteen
                Facility?)
              </p>
            </div>

            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="d-flex gap-3 w-75 ">
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="hasCanteen"
                    value="yes"
                    checked={formData.hasCanteen === "yes"}
                    onChange={handleInputChange}
                    ref={refs.hasCanteen}
                  />
                  Yes
                </label>

                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="hasCanteen"
                    value="no"
                    checked={formData.hasCanteen === "no"}
                    onChange={handleInputChange}
                  />
                  No
                </label>
              </div>
            </div>
          </div>

          {formData.hasCanteen === "yes" && (
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center p-2"></div>

              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-start">
                <div className="d-flex flex-column align-items-center gap-2">
                  <p className="m-0">
                    કેન્ટીનની બેઠકોની ક્ષમતા(Canteen Seating Capacity)
                  </p>
                  <input
                    type="number"
                    className="form-control w-75"
                    name="canteenSeatingCapacity"
                    placeholder="Enter Seating Capacity"
                    value={formData.canteenSeatingCapacity || ""}
                    onChange={handleInputChange}
                    min="0"
                  />
                  {errors && errors.canteenSeatingCapacity && (
                    <span className="text-danger small">
                      {errors.canteenSeatingCapacity}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                શું એપીએમસીમાં ગેસ્ટ હાઉસ / રેસ્ટ હાઉસ છે?(Whether APMC has
                Guest House / Rest House?)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="d-flex gap-3 w-75">
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="hasGuestHouse"
                    value="yes"
                    checked={formData.hasGuestHouse === "yes"}
                    onChange={handleInputChange}
                    ref={refs.hasGuestHouse}
                  />
                  Yes
                </label>
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="hasGuestHouse"
                    value="no"
                    checked={formData.hasGuestHouse === "no"}
                    onChange={handleInputChange}
                  />
                  No
                </label>
              </div>
            </div>
          </div>
          {formData.hasGuestHouse === "yes" && (
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center p-2"></div>

              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="d-flex flex-column align-items-start gap-2">
                  <p className="m-0">પથારીઓની ક્ષમતા (Number of Beds)</p>
                  <input
                    type="number"
                    className="form-control w-75"
                    name="noOfBeds"
                    placeholder="Enter Number of Beds"
                    value={formData.noOfBeds || ""}
                    onChange={handleInputChange}
                    min="0"
                  />
                  {errors && errors.noOfBeds && (
                    <span className="text-danger small">{errors.noOfBeds}</span>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Field 16 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              16.
            </h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                માળખાકીય સુવિધાઓની વિગતો(Details of Infrastructure Facilities)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <Select
                className="w-75"
                isMulti
                options={rawPurposes}
                value={formData.infrastructureDetails}
                placeholder="Select Infrastructure Facilities"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                onChange={(selected) => {
                  setFormData((prev) => ({
                    ...prev,
                    infrastructureDetails: selected as SelectOption[],
                  }));

                  setErrors((prev) => ({
                    ...prev,
                    infrastructureDetails: "",
                  }));
                }}
              />

              {errors && errors.infrastructureDetails && (
                <span className="text-danger small">
                  {errors.infrastructureDetails}
                </span>
              )}
            </div>
          </div>

          {/* Field 17 */}
          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center">
              17.
            </h4>
            <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">જમીનની વિગતો(Land Details)</p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
          </div>

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                શું એપીએમસી પાસે ખાનગી જમીન છે?(Whether APMC has Private Land?)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="d-flex gap-3 w-75">
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="hasPrivateLand"
                    value="yes"
                    checked={formData.hasPrivateLand === "yes"}
                    onChange={handleInputChange}
                    ref={refs.hasPrivateLand}
                  />
                  Yes
                </label>
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="hasPrivateLand"
                    value="no"
                    checked={formData.hasPrivateLand === "no"}
                    onChange={handleInputChange}
                  />
                  No
                </label>
              </div>
            </div>
          </div>
          {formData.hasPrivateLand === "yes" && (
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center p-2"></div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                <small className="text-muted">જમીન વિસ્તાર (Land Area)</small>
                <div className="d-flex  gap-2 w-75">
                  {/* Hectare */}
                  <div className="d-flex flex-column w-33">
                    <input
                      type="number"
                      className="form-control"
                      name="landHectare"
                      placeholder="00"
                      value={formData.landHectare || ""}
                      onChange={handleInputChange}
                      min="0"
                    />
                    {errors?.landHectare && (
                      <small className="text-danger">
                        {errors.landHectare}
                      </small>
                    )}
                  </div>

                  {/* Are */}
                  <div className="d-flex flex-column w-33">
                    <input
                      type="number"
                      className="form-control"
                      name="landAre"
                      placeholder="00"
                      value={formData.landAre || ""}
                      onChange={handleInputChange}
                      min="0"
                    />
                    {errors?.landAre && (
                      <small className="text-danger">{errors.landAre}</small>
                    )}
                  </div>

                  {/* Sq Meter */}
                  <div className="d-flex flex-column w-33">
                    <input
                      type="number"
                      className="form-control"
                      name="landSqMeter"
                      placeholder="00"
                      value={formData.landSqMeter || ""}
                      onChange={handleInputChange}
                      min="0"
                    />
                    {errors?.landSqMeter && (
                      <small className="text-danger">
                        {errors.landSqMeter}
                      </small>
                    )}
                  </div>
                </div>

                <small className="text-muted">
                  હેક્ટર – એર – ચોરસ મીટર (Hectare – Are – Sq. Meter)
                </small>
              </div>
            </div>
          )}

          <div className="d-flex border-bottom border-secondary">
            <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
            <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
              <p className="p-2">
                શું એપીએમસી પાસે ભાડે લીધેલી જમીન છે?(Whether APMC has Land on
                Lease?)
              </p>
            </div>
            <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
              <div className="d-flex gap-3 w-75">
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="hasLeasedLand"
                    value="yes"
                    checked={formData.hasLeasedLand === "yes"}
                    onChange={handleInputChange}
                    ref={refs.hasLeasedLand}
                  />
                  Yes
                </label>
                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="hasLeasedLand"
                    value="no"
                    checked={formData.hasLeasedLand === "no"}
                    onChange={handleInputChange}
                  />
                  No
                </label>
              </div>
            </div>
          </div>
          {formData.hasLeasedLand === "yes" && (
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center p-2"></div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                {/* Land Area */}
                <small className="text-muted">જમીન વિસ્તાર (Land Area)</small>

                <div className="d-flex gap-2 w-75">
                  {/* Hectare */}
                  <div className="d-flex flex-column w-33">
                    <input
                      type="number"
                      className="form-control"
                      name="leaseLandHectare"
                      placeholder="00"
                      value={formData.leaseLandHectare || ""}
                      onChange={handleInputChange}
                      min="0"
                    />
                    {errors?.leaseLandHectare && (
                      <small className="text-danger">
                        {errors.leaseLandHectare}
                      </small>
                    )}
                  </div>

                  {/* Are */}
                  <div className="d-flex flex-column w-33">
                    <input
                      type="number"
                      className="form-control"
                      name="leaseLandAre"
                      placeholder="00"
                      value={formData.leaseLandAre || ""}
                      onChange={handleInputChange}
                      min="0"
                    />
                    {errors?.leaseLandAre && (
                      <small className="text-danger">
                        {errors.leaseLandAre}
                      </small>
                    )}
                  </div>

                  {/* Sq Meter */}
                  <div className="d-flex flex-column w-33">
                    <input
                      type="number"
                      className="form-control"
                      name="leaseLandSqMeter"
                      placeholder="00"
                      value={formData.leaseLandSqMeter || ""}
                      onChange={handleInputChange}
                      min="0"
                    />
                    {errors?.leaseLandSqMeter && (
                      <small className="text-danger">
                        {errors.leaseLandSqMeter}
                      </small>
                    )}
                  </div>
                </div>

                <small className="text-muted">
                  હેક્ટર – એર – ચોરસ મીટર (Hectare – Are – Sq. Meter)
                </small>

                {/* Lease Period */}
                <small className="text-muted mt-3">
                  લીઝ સમયગાળો (વર્ષોમાં) – Lease Period (in years)
                </small>

                <div className="w-50">
                  <input
                    type="number"
                    className="form-control"
                    name="leasePeriodYears"
                    placeholder="Enter Lease Period in Years"
                    value={formData.leasePeriodYears || ""}
                    onChange={handleInputChange}
                    min="0"
                  />
                  {errors?.leasePeriodYears && (
                    <small className="text-danger">
                      {errors.leasePeriodYears}
                    </small>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex w-100 p-3">
          <button className="btn btn-info " onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default ApmcDetailApplicationForm;
